@if (_visible) {
  <div class="container">
    <div class="share-document">
      <div class="mb-4">
        <topo-icon-item-select
          [selectedUId]="uId"
          [icon]="selectedChannel?.channelIcon"
          [label]="selectedChannel?.name ?? 'MAP.SELECT-CHANNEL' | translate"
          itemLabel="name"
          itemIcon="channelIcon"
          [items]="channels ?? []"
          [isXLarge]="true"
          (itemSelected)="selectChannel($event)"
          [useTopoIcons]="true"></topo-icon-item-select>
      </div>
      @if (showTemplates) {
        <div class="mb-4">
          <topo-icon-item-select
            [selectedUId]="uId"
            [icon]="selectedTemplate?.channelIcon"
            [label]="selectedTemplate?.name ?? 'MAP.SELECT-COMMUNICATION-TEMPLATE' | translate"
            itemLabel="name"
            itemIcon="channelIcon"
            [items]="templates ?? []"
            [isXLarge]="true"
            (itemSelected)="selectTemplate($event)"
            [useTopoIcons]="true"></topo-icon-item-select>
        </div>
      }
      @if (showTextInput) {
        <div class="mb-4">
          <quill-editor
            [styles]="{ height: '104px' }"
            placeholder="{{ 'COMMENTS.ENTER-COMMENT' | translate }}"
            [modules]="editorModules"
            [(ngModel)]="message"
            (onEditorCreated)="editorCreated($event)"></quill-editor>
        </div>
      }
      <div
        fxLayout="row"
        fxLayoutAlign="end"
        class="mb-6">
        <div>
          <button
            type="button"
            class="button is-secondary mr-3 is-medium"
            (click)="cancel()">
            {{ 'MAP.BUTTON-CANCEL' | translate }}
          </button>
        </div>
        <div>
          <button
            type="button"
            class="button is-primary is-medium"
            (click)="send()">
            {{ (isPreviewButton ? 'MAP.BUTTON-PREVIEW' : 'MAP.BUTTON-SEND') | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
}

@if (isShareActive) {
  <topo-share-document-dialog
    [isActive]="isShareActive"
    [distanceDropdownValue]="distanceDropdownValue"
    [communicationMeta]="communicationMeta"
    [isClosestAssetWorking]="isClosestAssetWorking"
    [selectedDocumentAssetsByDistance]="selectedDocumentAssetsByDistance"
    [closestAssetsWithEmail]="emailClosestAssetData"
    [pathToMap]="pathToMap"
    [document]="document"
    [dataset]="dataset"
    [mapUId]="mapUId"></topo-share-document-dialog>
}

@if (isEverbridgeShareActive) {
  <topo-share-document-everbridge-dialog
    [isActive]="isEverbridgeShareActive"
    [distanceDropdownValue]="distanceDropdownValue"
    [communicationMeta]="communicationMeta"
    [isClosestAssetWorking]="isClosestAssetWorking"
    [selectedDocumentAssetsByDistance]="selectedDocumentAssetsByDistance"
    [pathToMap]="pathToMap"
    [document]="document"
    [dataset]="dataset"></topo-share-document-everbridge-dialog>
}
